import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { IToast } from '../../../interfaces/components/IToast';
import { IPaginationPayload } from '../../../interfaces/shared/IPaginationPayload';
import { tryToFetchInvitedPartners, tryToResendInvitePartner } from '../../../store/brokers/admin/partners/partnersSlice';
import InvitedPartnersTable from './tables/InvitedPartnersTable';
import Input from '../../../shared/input';
import Toast from '../../../shared/toast';

const InvitedPartners = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [rows, setRows] = useState<any[]>([]);
    const [search, setSearch] = useState<string>()
    const [showToast, setShowToast] = useState<IToast | null>()
    const [paginationState, setPaginationState] = useState<IPaginationPayload>({
        pageNumber: 1,
        pageSize: 10,
    });
    const paginationData = useAppSelector((state) => state.partners.invitedPartners?.data?.page);
    const rowsLoading = useAppSelector((state) => state.partners.invitedAreLoading);
    const state = useAppSelector((state) => state.partners);

    useEffect(() => {
        if (state.invitedPartners) {
            const rows =
                state.invitedPartners?.data?.elements && Array.isArray(state.invitedPartners?.data.elements)
                    ? state.invitedPartners?.data.elements.map((r: any) => ({ ...r, id: r._id }))
                    : [];
            setRows(rows);
        }
    }, [state.invitedPartners]);

    const onGettingFilters = (type?: string) => {
        let settingsFilters: any = {
            ...paginationState || {},
        }
        if (search) {
            settingsFilters.data = {
                ...settingsFilters.data,
                search: search
            }
        }
        return settingsFilters
    }

    const getInvitedPartnersData = async () => {
        const settingsFilters = onGettingFilters()
        await dispatch(tryToFetchInvitedPartners(settingsFilters));
    }

    const onResetPaginationState = () => {
        setPaginationState({
            pageNumber: 1,
            pageSize: paginationState?.pageSize || 10,
        })
    }

    useEffect(() => {
        getInvitedPartnersData()
    }, [paginationState])

    const onChangeSearch = (value: string | null | undefined, type: string) => {
        setSearch(value || undefined)
        onResetPaginationState()
    }

    const onGoBack = () => {
        navigate(-1)
    }

    const onResendLink = async (token: string) => {
        try {
            await dispatch(tryToResendInvitePartner({ token: token })).unwrap();
            setShowToast({ type: 'success', message: 'Invite Sent Successfully' })
        } catch (err) {
            setShowToast({ type: 'error', message: `${err}` })
        }
    }

    return (
        <div>
            <div className={'flex flex-row items-center justify-between'}>
                <div className='flex flex-row items-center'>
                    <div onClick={onGoBack} className='md:-ml-2 xl:-ml-4 md:mr-2 xl:mr-4'>
                        <img src={'/assets/shared/go-back.svg'} className={'w-[18px] object-contain cursor-pointer'} />
                    </div>
                    <p className='page-title'>Invited Partners</p>
                </div>
            </div>
            <div className={`flex flex-row justify-between items-center bg-call-default mt-3 p-1 !rounded`}>
                <Input
                    placeholder={'Search For Invitation'}
                    dataQa={'search'}
                    containerStyle='mb-0 pb-0 relative min-w-[60%]'
                    inputStyle={`mb-0 border-0 focus:outline-none`}
                    icon={'/assets/shared/search.svg'}
                    showValue={true}
                    inputValue={search}
                    inputUniqueName={'search'}
                    onChangeInput={onChangeSearch}
                    hideInputSpace={true}
                />
            </div>
            <InvitedPartnersTable
                rows={rows}
                rowsLoading={rowsLoading}
                paginationData={paginationData}
                onResendLink={onResendLink}
                setPaginationState={setPaginationState}
            />
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
        </div>
    )
}
export default InvitedPartners;